import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import Tabs from './../common/components/Tabs';
import AdminHeader from './../common/components/AdminHeader';
import { Order, Form, Delete, UploadArtworks, DeleteFile } from './components';
import * as selectors from './selectors';
import * as actions from './actions';
import * as dialog from '../common/dialog';
import * as loginSelectors from './../Login/Login.selectors';
import moment from 'moment';
import numeral from 'numeral';
import { Helmet } from 'react-helmet';
import cloneDeep from 'lodash/cloneDeep';
import { showNotification } from './../../utils';
import Layout from './../Layout';
import './styles.scss';

class Container extends Component {
    static propTypes = {
        isFetchingElements: PropTypes.bool,
        isSavingForm: PropTypes.bool,
        formValues: PropTypes.object,
        user: PropTypes.object,
        elements: PropTypes.array,
        saveElement: PropTypes.func,
        setSort: PropTypes.func,
        updateFormValue: PropTypes.func,
        fetchElements: PropTypes.func,
        totalPages: PropTypes.number,
        selectedPage: PropTypes.number,
        elementsPerPage: PropTypes.number,
        sortColumn: PropTypes.string,
        sortType: PropTypes.string,
        save: PropTypes.func,
        addElement: PropTypes.func,
        showForm: PropTypes.func,
        hideForm: PropTypes.func,
        resetForm: PropTypes.func,
        showDelete: PropTypes.func,
        hideDelete: PropTypes.func,
        setIdForDelete: PropTypes.func,
        deleteElement: PropTypes.func,
        idForDelete: PropTypes.number,
        changeAttribute: PropTypes.func,
        updateAttribute: PropTypes.func,
        formErrors: PropTypes.object,
        isFetchingElement: PropTypes.bool,
        isDeleting: PropTypes.bool,
        setActiveElement: PropTypes.func,
        setFormError: PropTypes.func,
        showInfoNotification: PropTypes.func,
        formErrorMessages: PropTypes.object,
        order: PropTypes.object,
        estimate: PropTypes.func,
        isLoadingEstimate: PropTypes.bool,
        isSavingEstimate: PropTypes.bool,
        estimateResults: PropTypes.array,
        saveEstimate: PropTypes.func,
        deleteEstimate: PropTypes.func,
        customerId: PropTypes.number,
        isFetchingOrder: PropTypes.bool,
        isFetchingInformation: PropTypes.bool,
        orderId: PropTypes.number,
        setItemQuantity: PropTypes.func,
        setCustomerId: PropTypes.func,
        setEditingCustomer: PropTypes.func,
        editingCustomer: PropTypes.bool,
        resetEstimateForm: PropTypes.func,
        activeProduct: PropTypes.object,
        setProduct: PropTypes.func,
        setAccessories: PropTypes.func,
        setFiles: PropTypes.func,
        estimateAccessories: PropTypes.array,
        clearResults: PropTypes.func,
        showUpload: PropTypes.func,
        clearFiles: PropTypes.func,
        uploadFiles: PropTypes.func,
        hideUpload: PropTypes.func,
        uploadingProgress: PropTypes.number,
        filename: PropTypes.string,
        isUploadingFile: PropTypes.bool,
        setFileEstimateId: PropTypes.func,
        deleteFile: PropTypes.func,
        setFileIdToDelete: PropTypes.func,
        showDeleteFile: PropTypes.func,
        hideDeleteFile: PropTypes.func,
        sendToProduction: PropTypes.func,
        files: PropTypes.array,
        fileEstimateId: PropTypes.number,
        isDeletingFile: PropTypes.bool,
        fileIdToDelete: PropTypes.number,
        isSendingToProduction: PropTypes.bool,
        updateOutsideService: PropTypes.func,
        addOutsideService: PropTypes.func,
        deleteOutsideService: PropTypes.func,
        information: PropTypes.object,
        options: PropTypes.object,
        loadProductOptions: PropTypes.func,
        resetState: PropTypes.func,
        calculateShipping: PropTypes.func,
        shipping: PropTypes.object,
        fetching: PropTypes.object,
        setLoading: PropTypes.func,
        intersectPaperWeights: PropTypes.func,
        intersectPresses: PropTypes.func,
        intersectPaperCategories: PropTypes.func,
        intersectPapers: PropTypes.func,
        fetchInformation: PropTypes.func,
        resetOptions: PropTypes.func,
        updateState: PropTypes.func,
        fetchEstimate: PropTypes.func,
        changeEstimateStatus: PropTypes.func,
        updateEstimateStatus: PropTypes.func,
        changeEstimateHaveArtworks: PropTypes.func,
        updateEstimateHaveArtworks: PropTypes.func,
        addMailingElement: PropTypes.func,
        updateMailingElement: PropTypes.func,
        removeMailingElement: PropTypes.func,
        updateMailingPrices: PropTypes.func
    };

    componentWillMount() {
        if (this.props.match.params.orderId) {
            this.props.setOrderId(this.props.match.params.orderId);
            this.props.fetchOrder(this.props.match.params.orderId);
        } else {
            this.props.resetEstimateForm();
            this.props.setEditingCustomer(1);
        }
        
        this.props.fetchInformation();
        this.props.setHistory(this.props.history);
    }

    componentWillUnmount() {
        const { resetState } = this.props;
        resetState();
    }

    handleUpdateFormValue(type, required, event) {
        const { setFormError, clearResults, setProduct, information, intersectPaperCategories,
            loadProductOptions, intersectPaperWeights, intersectPapers, intersectPresses, formValues,
            calculateShipping, updateState, updateMailingPrices } = this.props;

        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        let values = {};
        values[event.target.name] = value;
        let newValues = cloneDeep(formValues);
        newValues[event.target.name] = value;

        let error = false;
        let errorMessage = '';
        if (required && value === '') {
            error = true;
            errorMessage = 'This field is required';
        } else {
            if (value !== '' && type === 'number' && value.toString().match(/^[0-9]+$/) === null) {
                error = true;
                errorMessage = 'This value needs to be a number';
            } else if (value !== '' && type === 'decimal' && value.toString().match(/^([0-9]*[.])?[0-9]+$/) === null) {
                error = true;
                errorMessage = 'This value needs to be a number';
            }
        }

        let fetching = {};
        let options = {};
        if (event.target.name === 'estimate_paper_category_id') {
            intersectPaperWeights(newValues);
            fetching.paperWeights = true;
            options.paperWeights = [];
            options.papers = [{ label: 'Select option', value: '' }];
            values.estimate_paper_weight = '';
            values.estimate_paper_id = '';
        } else if (event.target.name === 'estimate_paper_weight') {
            intersectPapers(newValues);
            fetching.papers = true;
            options.papers = [];
            values.estimate_paper_id = '';
        } else if (event.target.name === 'estimate_cover_press_id') {
            intersectPaperCategories(newValues, true);
            fetching.coverPaperCategories = true;
            options.coverPaperCategories = [];
            options.coverPaperWeights = [{ label: 'Select option', value: '' }];
            options.coverPapers = [{ label: 'Select option', value: '' }];
            values.estimate_cover_paper_category_id = '';
            values.estimate_cover_paper_weight = '';
            values.estimate_cover_paper_id = '';
            values.estimate_cover_running_style = '';
        } else if (event.target.name === 'estimate_cover_paper_category_id') {
            intersectPaperWeights(newValues, true);
            fetching.coverPaperWeights = true;
            options.coverPaperWeights = [];
            options.coverPapers = [{ label: 'Select option', value: '' }];
            values.estimate_cover_paper_weight = '';
            values.estimate_cover_paper_id = '';
        } else if (event.target.name === 'estimate_cover_paper_weight') {
            intersectPapers(newValues, true);
            fetching.coverPapers = true;
            options.coverPapers = [];
            values.estimate_cover_paper_id = '';
        } else if (event.target.name === 'estimate_type') {
            clearResults(value);
            loadProductOptions(value);
            intersectPaperCategories(newValues);
            fetching.paperCategories = true;
            options.paperCategories = [];
            options.paperWeights = [{ label: 'Select option', value: '' }];
            options.papers = [{ label: 'Select option', value: '' }];
            values.estimate_paper_category_id = '';
            values.estimate_paper_weight = '';
            values.estimate_paper_id = '';

            if ([2, 3, 6, 7].includes(formValues['estimate_multi_page_type'])) {
                intersectPaperCategories(newValues, true);
                fetching.coverPaperCategories = true;
                options.coverPaperCategories = [];
                options.coverPaperWeights = [{ label: 'Select option', value: '' }];
                options.coverPapers = [{ label: 'Select option', value: '' }];
                values.estimate_cover_paper_category_id = '';
                values.estimate_cover_paper_weight = '';
                values.estimate_cover_paper_id = '';
            }
        } else if (event.target.name === 'estimate_press_id') {
            intersectPaperCategories(newValues);
            fetching.paperCategories = true;
            options.paperCategories = [];
            options.paperWeights = [{ label: 'Select option', value: '' }];
            options.papers = [{ label: 'Select option', value: '' }];
            values.estimate_paper_category_id = '';
            values.estimate_paper_weight = '';
            values.estimate_paper_id = '';
            values.estimate_running_style = '';
        } else if (event.target.name === 'estimate_second_press_id') {
            intersectPaperCategories(newValues);
            fetching.paperCategories = true;
            options.paperCategories = [];
            options.paperWeights = [{ label: 'Select option', value: '' }];
            options.papers = [{ label: 'Select option', value: '' }];
            values.estimate_paper_category_id = '';
            values.estimate_paper_weight = '';
            values.estimate_paper_id = '';
            values.estimate_running_style = '';
        } else if (event.target.name === 'estimate_digital_machine_id') {
            intersectPaperCategories(newValues);
            fetching.paperCategories = true;
            options.paperCategories = [];
            options.paperWeights = [{ label: 'Select option', value: '' }];
            options.papers = [{ label: 'Select option', value: '' }];
            values.estimate_paper_category_id = '';
            values.estimate_paper_weight = '';
            values.estimate_paper_id = '';
        } else if (event.target.name === 'estimate_multi_page_type') {
            clearResults(value);
        } else if (event.target.name === 'estimate_product_id') {
            setProduct(information['products'], value);

            let product = null;
            for (let i = 0; i < information['products'].length; i++) {
                if (parseInt(information['products'][i]['id']) === parseInt(value)) {
                    product = information['products'][i];
                }
            }

            newValues['estimate_type'] = product['type'];
            newValues['estimate_cover_press_id'] = product['cover_press_id'];
            newValues['estimate_press_id'] = product['press_id'];
            newValues['estimate_second_press_id'] = product['second_press_id'];
            newValues['estimate_digital_machine_id'] = product['digital_machine_id'];
            newValues['estimate_product_id'] = product['product_id'];
            newValues['estimate_cover_paper_category_id'] = product['cover_paper_category_id'];
            newValues['estimate_paper_category_id'] = product['paper_category_id'];
            newValues['estimate_cover_paper_weight'] = product['cover_paper_weight'];
            newValues['estimate_paper_weight'] = product['paper_weight'];

            intersectPresses();
            intersectPaperCategories(newValues);
            intersectPaperWeights(newValues);
            intersectPapers(newValues);
            fetching.paperCategories = true;
            fetching.paperWeights = true;
            fetching.papers = true;
            options.paperCategories = [];
            options.paperWeights = [];
            options.papers = [];

            if ([2, 3, 6, 7].includes(parseInt(product['multi_page_type']))) {
                intersectPaperCategories(newValues, true);
                intersectPaperWeights(newValues, true);
                intersectPapers(newValues, true);
                fetching.coverPaperCategories = true;
                fetching.coverPaperWeights = true;
                fetching.coverPapers = true;
                options.coverPaperCategories = [];
                options.coverPaperWeights = [];
                options.coverPapers = [];
            }
        } else if (event.target.name === 'shipping_method' && value !== '' && formValues['id'] !== '') {
            calculateShipping(value);
        } else if (event.target.name === 'estimate_customer_discount_id') {
            setTimeout(() => {
                updateMailingPrices();
            }, 50);
        }

        let newState = { formValues: values };

        let keys = Object.keys(fetching);
        if (keys.length > 0) {
            newState.fetching = fetching;
        }

        keys = Object.keys(options);
        if (keys.length > 0) {
            newState.options = options;
        }

        updateState(newState);
        setFormError(event.target.name, error, errorMessage);
    }

    handleSort(column) {
        const { setSort, sortColumn, sortType } = this.props;
        if (sortColumn === column) {
            setSort(column, sortType === 'asc' ? 'desc' : 'asc');
        } else {
            setSort(column, 'asc');
        }
    }

    handleInlineChange(index, attribute, value) {
        const { elements, changeAttribute } = this.props;
        changeAttribute(value, elements, index, attribute);
    }

    handleDayChange(index, attribute, day) {
        const { elements, changeAttribute } = this.props;
        changeAttribute(moment(day).format('YYYY-MM-DD'), elements, index, attribute);
    }

    handleSaveElement() {
        const { saveElement, formValues, elements, customerId } = this.props;
        saveElement(formValues, elements, customerId);
    }

    handleShowForm(id) {
        const { showForm, resetEstimateForm, information, intersectPresses, formValues,
            intersectPaperCategories, loadProductOptions,
            updateState, fetchEstimate, updateFormValue } = this.props;

        let fetching = {};
        let options = {};
        if (id == null) {
            resetEstimateForm(id);
            intersectPresses();
            intersectPaperCategories(formValues);
            fetching.paperCategories = true;
            options.paperCategories = [];
            options.paperWeights = [{ label: 'Select option', value: '' }];
            options.papers = [{ label: 'Select option', value: '' }];

            if ([2, 3, 6, 7].includes(formValues['estimate_multi_page_type'])) {
                intersectPaperCategories(formValues, true);
                fetching.coverPaperCategories = true;
                options.coverPaperCategories = [];
                options.coverPaperWeights = [{ label: 'Select option', value: '' }];
                options.coverPapers = [{ label: 'Select option', value: '' }];
            }

            loadProductOptions(1);

            if (information['estimates'].length === 0) {
                updateFormValue('estimate_product_description', formValues['name']);
            }
        } else {
            fetchEstimate(id);
        }

        let newState = {};

        let keys = Object.keys(fetching);
        if (keys.length > 0) {
            newState.fetching = fetching;
        }

        keys = Object.keys(options);
        if (keys.length > 0) {
            newState.options = options;
        }

        updateState(newState);
        showForm();
    }

    handleUpdateDayValue(name, day) {
        const { updateFormValue, setFormError } = this.props;
        updateFormValue(name, day);
        setFormError(name, day === '');
    }

    handleShowDelete(id, event) {
        const { showDelete, setIdForDelete } = this.props;
        event.preventDefault();
        showDelete();
        setIdForDelete(id);
    }

    handleDeleteElement() {
        const { deleteEstimate, idForDelete, information } = this.props;
        deleteEstimate(idForDelete, information['estimates']);
    }

    handleShowDeleteFile(id, event) {
        const { showDeleteFile, setFileIdToDelete } = this.props;
        event.preventDefault();
        showDeleteFile();
        setFileIdToDelete(id);
    }

    handleDeleteFile() {
        const { deleteFile, fileIdToDelete, information } = this.props;
        deleteFile(fileIdToDelete, information['estimates']);
    }

    handleChangeAttribute(index, attribute, type, value) {
        const { elements, changeAttribute, updateAttribute } = this.props;

        let valueToSave = value;
        if (type === 'money') {
            valueToSave = numeral(value).format('0.00');
            value = numeral(value).format('$0,0.00');
        } else if (type === 'number') {
            if (parseInt(value).toString().match(/^[0-9]+$/) == null) {
                showNotification('Wrong Value', 'This value needs to be a number', 'info');
                return;
            }
            valueToSave = numeral(value).format('0');
            value = numeral(value).format('0,0');
        } else if (type === 'date') {
            valueToSave = moment(value).format('YYYY-MM-DD');
            value = valueToSave;
        } else if (type === 'decimal') {
            if (parseInt(value).toString().match(/^([0-9]*[.])?[0-9]+$/) == null) {
                showNotification('Wrong Value', 'This value needs to be a number', 'info');
                return;
            }
            valueToSave = numeral(value).format('0');
            value = numeral(value).format('0,0');
        }

        changeAttribute(value, elements, index, attribute);
        updateAttribute(elements[index].id, attribute, valueToSave, elements, index);
    }

    handleEstimate() {
        const { estimate, formValues } = this.props;
        estimate(formValues);
    }

    handleSaveEstimate() {
        const { saveEstimate, formValues, estimateResults, information, orderId } = this.props;
        saveEstimate(formValues, estimateResults, information['estimates'], orderId);
    }

    handleSetItemQuantity(index, quantity) {
        const { setItemQuantity, information } = this.props;
        setItemQuantity(information['estimates'], index, quantity);
    }

    handleSetCustomerId(event) {
        const { setCustomerId, setEditingCustomer } = this.props;
        setCustomerId(event.target.value);
        setEditingCustomer(0);
    }

    handleEditingCustomer(editing) {
        const { setEditingCustomer } = this.props;
        setEditingCustomer(editing);
    }

    handleAccessoryClick(id, event) {
        const { setAccessories, estimateAccessories } = this.props;
        setAccessories(estimateAccessories, id, event.target.checked);
    }

    handleShowUploadArtworks(id) {
        const { showUpload, clearFiles, setFileEstimateId } = this.props;
        clearFiles();
        showUpload();
        setFileEstimateId(id);
    }

    handleDropFile(files) {
        const { setFiles } = this.props;
        setFiles(files);
    }

    handleUpload() {
        const { files, uploadFiles, fileEstimateId, user, information } = this.props;
        uploadFiles(files, user.id, fileEstimateId, information['estimates']);
    }

    handleProduction() {
        const { information, sendToProduction, orderId } = this.props;
        sendToProduction(orderId, information['estimates']);
    }

    handleAddOutsideService() {
        const { addOutsideService, formValues, updateMailingPrices } = this.props;
        addOutsideService({ cost: '', percentage_markup: '', description: '' });

        if (![1, 2, 3, 4].includes(parseInt(formValues['type']))) {
            setTimeout(() => {
                updateMailingPrices();
            }, 50);
        }
    }

    handleDeleteOutsideService(index) {
        const { deleteOutsideService, formValues, updateMailingPrices } = this.props;
        deleteOutsideService(index);

        if (![1, 2, 3, 4].includes(parseInt(formValues['type']))) {
            setTimeout(() => {
                updateMailingPrices();
            }, 50);
        }
    }

    handleUpdateOutsideService(name, index, event) {
        const { updateOutsideService, formValues, updateMailingPrices } = this.props;
        formValues['estimate_outside_services'][index][name] = event.target.value;
        updateOutsideService(index, formValues['estimate_outside_services'][index]);

        if (![1, 2, 3, 4].includes(parseInt(formValues['type']))) {
            setTimeout(() => {
                updateMailingPrices();
            }, 50);
        }
    }

    handleChangeEstimateStatus(id, index, event) {
        const { changeEstimateStatus, updateEstimateStatus } = this.props;
        changeEstimateStatus(id, event.target.value);
        updateEstimateStatus(index, event.target.value);
    }

    handleChangeEstimateHaveArtworks(id, index, event) {
        const { changeEstimateHaveArtworks, updateEstimateHaveArtworks } = this.props;
        changeEstimateHaveArtworks(id, event.target.checked ? 1 : 0);
        updateEstimateHaveArtworks(index, event.target.checked ? 1 : 0);
    }

    handleUpdateFormDateValue(name, required, event) {
        const { updateFormValue } = this.props;
        let value = event === undefined ? '' : moment(event).format('YYYY-MM-DD');
        updateFormValue(name, value);
    }

    handleUpdateMailingElement(name, attribute, index, event) {
        const { updateMailingElement, updateMailingPrices } = this.props;
        updateMailingElement(name, attribute, index, event.target.value);
        setTimeout(() => {
            updateMailingPrices();
        }, 50);
    }

    handleRemoveMailingElement(name, index) {
        const { removeMailingElement, updateMailingPrices } = this.props;
        removeMailingElement(name, index);
        setTimeout(() => {
            updateMailingPrices();
        }, 50);
    }

    render() {
        const { isFetchingElements, elements, sortColumn, sortType, totalPages, selectedPage, elementsPerPage, user,
            isSavingForm, formValues, formErrors, isFetchingElement, hideForm, isDeleting, hideDelete, formErrorMessages,
            order, isLoadingEstimate, estimateResults, isSavingEstimate, isFetchingOrder, orderId, isFetchingInformation,
            editingCustomer, customerId, activeProduct, estimateAccessories, files, isUploadingFile, uploadingProgress,
            hideUpload, isDeletingFile, hideDeleteFile, isSendingToProduction, information, options, shipping,
            fetching, addMailingElement } = this.props;
        return (
            <Layout>
                <div id="order-container" className="container-fluid">
                    <Helmet>
                        <title>Dashboard</title>
                        <meta name="description" content="" />
                    </Helmet>
                    <AdminHeader
                        title={orderId === '' ? 'New Order' : 'Edit Order'}
                    />
                    <div className="row">
                        <div className="col">
                            <Tabs
                                user={user}
                            />
                            <Order
                                elements={elements}
                                isFetchingElements={isFetchingElements}
                                totalPages={totalPages}
                                selectedPage={selectedPage}
                                elementsPerPage={elementsPerPage}
                                sortColumn={sortColumn}
                                sortType={sortType}
                                user={user}
                                formValues={formValues}
                                formErrors={formErrors}
                                formErrorMessages={formErrorMessages}
                                isSavingForm={isSavingForm}
                                isFetchingElement={isFetchingElement}
                                information={information}
                                options={options}
                                order={order}
                                isFetchingOrder={isFetchingOrder}
                                isFetchingInformation={isFetchingInformation}
                                customerId={customerId}
                                editingCustomer={editingCustomer}
                                orderId={orderId}
                                isSendingToProduction={isSendingToProduction}
                                shipping={shipping}
                                handleSort={this.handleSort.bind(this)}
                                handleChangeAttribute={this.handleChangeAttribute.bind(this)}
                                handleInlineChange={this.handleInlineChange.bind(this)}
                                handleShowDelete={this.handleShowDelete.bind(this)}
                                handleShowForm={this.handleShowForm.bind(this)}
                                handleDayChange={this.handleDayChange.bind(this)}
                                handleUpdateFormValue={this.handleUpdateFormValue.bind(this)}
                                handleSaveElement={this.handleSaveElement.bind(this)}
                                handleSetItemQuantity={this.handleSetItemQuantity.bind(this)}
                                handleEditingCustomer={this.handleEditingCustomer.bind(this)}
                                handleSetCustomerId={this.handleSetCustomerId.bind(this)}
                                handleShowUploadArtworks={this.handleShowUploadArtworks.bind(this)}
                                handleShowDeleteFile={this.handleShowDeleteFile.bind(this)}
                                handleProduction={this.handleProduction.bind(this)}
                                handleChangeEstimateStatus={this.handleChangeEstimateStatus.bind(this)}
                                handleChangeEstimateHaveArtworks={this.handleChangeEstimateHaveArtworks.bind(this)}
                                handleUpdateFormDateValue={this.handleUpdateFormDateValue.bind(this)}
                            />
                            <Form
                                formValues={formValues}
                                formErrors={formErrors}
                                formErrorMessages={formErrorMessages}
                                isSavingForm={isSavingForm}
                                isFetchingElement={isFetchingElement}
                                isLoadingEstimate={isLoadingEstimate}
                                estimateResults={estimateResults}
                                isSavingEstimate={isSavingEstimate}
                                activeProduct={activeProduct}
                                estimateAccessories={estimateAccessories}
                                information={information}
                                options={options}
                                fetching={fetching}
                                handleUpdateFormValue={this.handleUpdateFormValue.bind(this)}
                                handleUpdateDayValue={this.handleUpdateDayValue.bind(this)}
                                hideForm={hideForm.bind(this)}
                                handleSaveElement={this.handleSaveElement.bind(this)}
                                handleEstimate={this.handleEstimate.bind(this)}
                                handleSaveEstimate={this.handleSaveEstimate.bind(this)}
                                handleAccessoryClick={this.handleAccessoryClick.bind(this)}
                                handleAddOutsideService={this.handleAddOutsideService.bind(this)}
                                handleDeleteOutsideService={this.handleDeleteOutsideService.bind(this)}
                                handleUpdateOutsideService={this.handleUpdateOutsideService.bind(this)}
                                addMailingElement={addMailingElement.bind(this)}
                                handleUpdateMailingElement={this.handleUpdateMailingElement.bind(this)}
                                handleRemoveMailingElement={this.handleRemoveMailingElement.bind(this)}
                            />
                            <Delete
                                isDeleting={isDeleting}
                                hideDelete={hideDelete.bind(this)}
                                handleDeleteElement={this.handleDeleteElement.bind(this)}
                            />
                            <DeleteFile
                                isDeletingFile={isDeletingFile}
                                hideDeleteFile={hideDeleteFile.bind(this)}
                                handleDeleteFile={this.handleDeleteFile.bind(this)}
                            />
                            <UploadArtworks
                                isUploadingFile={isUploadingFile}
                                uploadingProgress={uploadingProgress}
                                files={files}
                                hideUpload={hideUpload.bind(this)}
                                handleUpload={this.handleUpload.bind(this)}
                                handleDropFile={this.handleDropFile.bind(this)}
                            />
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    formValues: selectors.getFormValues,
    formErrors: selectors.getFormErrors,
    formErrorMessages: selectors.getFormErrorsMessages,
    isSavingForm: selectors.getIsSavingForm,
    elements: selectors.getElements,
    isFetchingElements: selectors.getIsFetchingElements,
    isDeleting: selectors.getIsDeleting,
    idForDelete: selectors.getIdForDelete,
    totalPages: selectors.getTotalPages,
    selectedPage: selectors.getSelectedPage,
    elementsPerPage: selectors.getElementsPerPage,
    sortColumn: selectors.getSortColumn,
    sortType: selectors.getSortType,
    customerId: selectors.getCustomerId,
    orderId: selectors.getOrderId,
    order: selectors.getOrder,
    isFetchingOrder: selectors.getIsFetchingOrder,
    isFetchingInformation: selectors.getIsFetchingInformation,
    isLoadingEstimate: selectors.getIsLoadingEstimate,
    estimateResults: selectors.getEstimateResults,
    isSavingEstimate: selectors.getIsSavingEstimate,
    editingCustomer: selectors.getEditingCustomer,
    activeProduct: selectors.getActiveProduct,
    estimateAccessories: selectors.getEstimateAccessories,
    files: selectors.getFiles,
    isUploadingFile: selectors.getIsUploadingFile,
    filename: selectors.getFilename,
    uploadingProgress: selectors.getUploadingProgress,
    fileEstimateId: selectors.getFileEstimateId,
    isDeletingFile: selectors.getIsDeletingFile,
    fileIdToDelete: selectors.getFileIdToDelete,
    isSendingToProduction: selectors.getIsSendingToProduction,
    information: selectors.getInformation,
    options: selectors.getOptions,
    shipping: selectors.getShipping,
    fetching: selectors.getFetching,
    user: loginSelectors.getUser
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchElements: () => dispatch(actions.fetchElements()),
        updateFormValue: (name, value) => dispatch(actions.updateFormValue(name, value)),
        setSort: (column, type) => dispatch(actions.setSort(column, type)),
        deleteElement: (id, elements) => dispatch(actions.deleteElement(id, elements)),
        deleteEstimate: (id, estimates) => dispatch(actions.deleteEstimate(id, estimates)),
        showDelete: () => dispatch(dialog.actions.showDialog('delete')),
        hideDelete: () => dispatch(dialog.actions.hideDialog('delete')),
        showForm: () => dispatch(dialog.actions.showDialog('form')),
        hideForm: () => dispatch(dialog.actions.hideDialog('form')),
        showUpload: () => dispatch(dialog.actions.showDialog('upload-artworks')),
        hideUpload: () => dispatch(dialog.actions.hideDialog('upload-artworks')),
        showDeleteFile: () => dispatch(dialog.actions.showDialog('delete-file')),
        hideDeleteFile: () => dispatch(dialog.actions.hideDialog('delete-file')),
        setIdForDelete: (value) => dispatch(actions.setIdForDelete(value)),
        saveElement: (values, elements, customerId) => dispatch(actions.saveElement(values, elements, customerId)),
        setFormError: (name, value, message) => dispatch(actions.setFormError(name, value, message)),
        resetForm: () => dispatch(actions.resetForm()),
        resetEstimateForm: () => dispatch(actions.resetEstimateForm()),
        changeAttribute: (value, elements, index, attribute) => dispatch(actions.changeAttribute(value, elements, index, attribute)),
        updateAttribute: (id, attribute, value, elements, index) => dispatch(actions.updateAttribute(id, attribute, value, elements, index)),
        setActiveElement: (elements, id, products) => dispatch(actions.setActiveElement(elements, id, products)),
        estimate: (values) => dispatch(actions.estimate(values)),
        saveEstimate: (values, estimateResults, estimates, orderId) => dispatch(actions.saveEstimate(values, estimateResults, estimates, orderId)),
        setItemQuantity: (estimates, index, quantity) => dispatch(actions.setItemQuantity(estimates, index, quantity)),
        setCustomerId: (id) => dispatch(actions.setCustomerId(id)),
        setEditingCustomer: (editing) => dispatch(actions.setEditingCustomer(editing)),
        clearResults: (value) => dispatch(actions.clearResults(value)),
        setProduct: (products, productId) => dispatch(actions.setProduct(products, productId)),
        setAccessories: (accessories, id, checked) => dispatch(actions.setAccessories(accessories, id, checked)),
        uploadFiles: (files, userId, estimateId, estimates) => dispatch(actions.uploadFiles(files, userId, estimateId, estimates)),
        setFiles: (files) => dispatch(actions.setFiles(files)),
        clearFiles: () => dispatch(actions.clearFiles()),
        setFileEstimateId: (id) => dispatch(actions.setFileEstimateId(id)),
        setFileIdToDelete: (id) => dispatch(actions.setFileIdToDelete(id)),
        deleteFile: (id, estimates) => dispatch(actions.deleteFile(id, estimates)),
        sendToProduction: (orderId, estimates) => dispatch(actions.sendToProduction(orderId, estimates)),
        addOutsideService: (value) => dispatch(actions.addOutsideService(value)),
        deleteOutsideService: (index) => dispatch(actions.deleteOutsideService(index)),
        updateOutsideService: (index, value) => dispatch(actions.updateOutsideService(index, value)),
        intersectPresses: () => dispatch(actions.intersectPresses()),
        intersectPaperCategories: (formValues, isCover) => dispatch(actions.intersectPaperCategories(formValues, isCover)),
        intersectPaperWeights: (formValues, isCover) => dispatch(actions.intersectPaperWeights(formValues, isCover)),
        intersectPapers: (formValues, isCover) => dispatch(actions.intersectPapers(formValues, isCover)),
        loadProductOptions: (type) => dispatch(actions.loadProductOptions(type)),
        resetState: () => dispatch(actions.resetState()),
        calculateShipping: (shippingMethod) => dispatch(actions.calculateShipping(shippingMethod)),
        setLoading: (name, value) => dispatch(actions.setLoading(name, value)),
        resetOptions: (name) => dispatch(actions.resetOptions(name)),
        fetchInformation: () => dispatch(actions.fetchInformation()),
        updateState: (values) => dispatch(actions.updateState(values)),
        fetchEstimate: (id) => dispatch(actions.fetchEstimate(id)),
        changeEstimateStatus: (id, value) => dispatch(actions.changeEstimateStatus(id, value)),
        updateEstimateStatus: (index, value) => dispatch(actions.updateEstimateStatus(index, value)),
        changeEstimateHaveArtworks: (index, value) => dispatch(actions.changeEstimateHaveArtworks(index, value)),
        updateEstimateHaveArtworks: (index, value) => dispatch(actions.updateEstimateHaveArtworks(index, value)),
        addMailingElement: (name, value) => dispatch(actions.addMailingElement(name, value)),
        updateMailingElement: (name, attribute, index, value) => dispatch(actions.updateMailingElement(name, attribute, index, value)),
        removeMailingElement: (name, index) => dispatch(actions.removeMailingElement(name, index)),
        updateMailingPrices: () => dispatch(actions.updateMailingPrices()),
        setOrderId: (id) => dispatch(actions.setOrderId(id)),
        fetchOrder: (id) => dispatch(actions.fetchOrder(id)),
        setHistory: (history) => dispatch(actions.setHistory(history))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Container);
